import { Typography } from '@mui/material'
import { C1ChipProps } from 'c1ui/components/C1Chip'
import { DisplayNameDetails } from 'components/core/display-name-details'
import { GetStepUpProviderRequest, StepUpProvider } from 'pbts/c1/api/stepup/v1/stepup'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getStepUpProviderApi } from 'redux_toolkit/step-up-providers'

type StepUpProviderDisplayProps = {
    providerId: string
}

export const getProviderUrl = (p: StepUpProvider): string => {
    // Strip https:// or http:// from the URL for display
    return p.issuerUrl.replace(/^https?:\/\//, '')
}

export const StepUpProviderDisplay: FC<StepUpProviderDisplayProps> = ({ providerId }) => {
    const { data: response, isLoading } = getStepUpProviderApi.useGet(
        GetStepUpProviderRequest.create({
            id: providerId,
        }),
        { notify: false },
    )

    if (isLoading || !response?.stepUpProvider) {
        return null
    }

    const provider = response.stepUpProvider

    const getProviderTypeChip = (p: StepUpProvider): C1ChipProps | undefined => {
        const type = p.settings.oneofKind === 'oauth2' ? (
            <FormattedMessage id="step_up_provider_type_oauth2" defaultMessage="OAuth2" />
        ) : p.settings.oneofKind === 'microsoft' ? (
            <FormattedMessage id="step_up_provider_type_microsoft" defaultMessage="Microsoft Entra" />
        ) : null

        return type ? {
            label: type,
            color: 'default',
        } : undefined
    }

    return (
        <DisplayNameDetails
            displayName={provider.displayName}
            details={<Typography>{getProviderUrl(provider)}</Typography>}
            identifier={getProviderTypeChip(provider)}
            isDeleted={!provider.enabled}
            readOnly
        />
    )
}
